module.exports = __webpack_public_path__ + "img/logo-login.08e19257.png";